import {Component} from '@angular/core'
import {RouterLink} from '@angular/router'
import {LogoComponent, ToggleButtonComponent} from '@sparbanken-syd/sparbanken-syd-theme'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    RouterLink,
    LogoComponent,
    ToggleButtonComponent
  ]
})
export class HeaderComponent {
}
